import { useEffect, useState } from "react";

const KEY = "codigo_countdown_end";
const DURATION = 24 * 60 * 60 * 1000;

export function Countdown() {
  const [remaining, setRemaining] = useState(DURATION);

  useEffect(() => {
    let end = Number(localStorage.getItem(KEY));
    if (!end || end < Date.now()) {
      end = Date.now() + DURATION;
      localStorage.setItem(KEY, String(end));
    }
    const tick = () => {
      const r = Math.max(0, end - Date.now());
      setRemaining(r);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const h = Math.floor(remaining / 3600000);
  const m = Math.floor((remaining % 3600000) / 60000);
  const s = Math.floor((remaining % 60000) / 1000);
  const pad = (n: number) => String(n).padStart(2, "0");

  const Box = ({ v, label }: { v: string; label: string }) => (
    <div className="flex flex-col items-center">
      <div className="card-elegant min-w-[88px] px-4 py-5 font-serif text-4xl text-gold md:min-w-[120px] md:text-6xl">
        {v}
      </div>
      <span className="mt-2 text-[10px] tracking-[0.3em] text-gold/70 md:text-xs">
        {label}
      </span>
    </div>
  );

  return (
    <div className="flex items-center justify-center gap-3 md:gap-5">
      <Box v={pad(h)} label="HORAS" />
      <span className="font-serif text-3xl text-gold/50 md:text-5xl">:</span>
      <Box v={pad(m)} label="MIN" />
      <span className="font-serif text-3xl text-gold/50 md:text-5xl">:</span>
      <Box v={pad(s)} label="SEG" />
    </div>
  );
}
